   // frontend/src/pages/WidgetList.js
   import React, { useEffect, useState } from 'react';
   import axios from 'axios';
   import { Link, useNavigate } from 'react-router-dom';
   import { useAuth } from '../utils/AuthContext'; // Import the Auth context
   import { Modal, Button } from 'react-bootstrap'; // Import Bootstrap components for modal

   const WidgetList = () => {
     const { currentUser } = useAuth(); // Get the current user from context
     const [widgets, setWidgets] = useState([]);
     const [error, setError] = useState(''); // Add error state
     const [showEmbedModal, setShowEmbedModal] = useState(false); // State for modal visibility
     const [embedCode, setEmbedCode] = useState(''); // State for embed code
     const navigate = useNavigate(); // Hook for navigation

     useEffect(() => {
       const fetchWidgets = async () => {
         try {
           if (!currentUser) {
             console.error('User not authenticated');
             setError('User not authenticated'); // Set error message
             return;
           }

           const orgId = currentUser.organizationId; // Get organization ID from authenticated user
           const token = localStorage.getItem('token');
           if (!token) {
             console.error('No token found');
             setError('No token found. Please log in again.'); // Set error message
             return;
           }

           const response = await axios.get(`/api/widgets/organization/${orgId}`, {
             headers: {
               Authorization: `Bearer ${token}`
             }
           });
           setWidgets(response.data);
         } catch (error) {
           console.error('Error fetching widgets:', error.response ? error.response.data : error.message);
           setError(error.response?.data?.message || 'Failed to fetch widgets.'); // Set error message
         }
       };

       fetchWidgets();
     }, [currentUser]); // Add currentUser as a dependency

     const handleEdit = (widgetId) => {
       // Navigate to the edit page for the widget
       navigate(`/widgets/edit/${widgetId}`);
     };

     const handleEmbed = (widgetId) => {
       // Generate the embed code for the widget
       const host = window.location.origin;
       const embedCode = `<script src="${host}/api/embed/widget.js?id=${widgetId}" async></script>`;
       setEmbedCode(embedCode); // Set the embed code state
       setShowEmbedModal(true); // Show the modal
     };

     const handleCloseModal = () => {
       setShowEmbedModal(false); // Close the modal
     };

     return (
       <div>
         <h1>Widget Configurations</h1>
         {error && <p className="text-danger">{error}</p>} {/* Display error message */}
         <Link to="/widgets/create" className="btn btn-primary mb-3">Create New Widget</Link>
         <table className="table table-striped">
           <thead>
             <tr>
               <th>Name</th>
               <th>Agent ID</th>
               <th>Theme Color</th>
               <th>Actions</th>
             </tr>
           </thead>
           <tbody>
             {widgets.length > 0 ? (
               widgets.map(widget => (
                 <tr key={widget.id}>
                   <td>{widget.name}</td>
                   <td>{widget.agentId}</td>
                   <td>{widget.themeColor}</td>
                   <td>
                     <button className="btn btn-info me-2" onClick={() => handleEdit(widget.id)}>Edit</button>
                     <button className="btn btn-secondary" onClick={() => handleEmbed(widget.id)}>Embed</button>
                   </td>
                 </tr>
               ))
             ) : (
               <tr>
                 <td colSpan="4">No widgets found. Please create a new widget.</td>
               </tr>
             )}
           </tbody>
         </table>

         {/* Embed Code Modal */}
         <Modal show={showEmbedModal} onHide={handleCloseModal}>
           <Modal.Header closeButton>
             <Modal.Title>Embed Code</Modal.Title>
           </Modal.Header>
           <Modal.Body>
             <pre>{embedCode}</pre>
           </Modal.Body>
           <Modal.Footer>
             <Button variant="secondary" onClick={handleCloseModal}>
               Close
             </Button>
           </Modal.Footer>
         </Modal>
       </div>
     );
   };

   export default WidgetList;